export default function editHousingCorporationName(
  {patch}: any,
  {cid, municipality}: {cid: number; municipality: string},
): Promise<{}> {
  return patch(
    `/housing-corporations/municipality?corporationId=${cid}`,
    {municipality},
    {retryOn401: true},
  )
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationMunicipality.tsx